module.exports = __webpack_public_path__ + "img/snowy-3.b6eea2cf.svg";